const bidContextInitialState = {
  auctionSummary: undefined,
  bidStatus: undefined,
  presetBidAmount: undefined,
  currentBidAmount: undefined,
  currentProxyAmount: undefined,
  currentUpcomingProxy: undefined,
  details: undefined,
  id: undefined,
  isAuctionEnded: undefined,
  isOutBidSameDealer: undefined,
  isOutBidSameDGN: undefined,
  isSettingProxy: undefined,
  mediaCounts: undefined,
  numberOfBids: undefined,
  tradeState: undefined,
  upcomingProxy: undefined,
  variant: undefined,
  hasVehicleHistoryReport: undefined,
  bidSource: undefined,
  confirmation: false,
  highBid: false,
  outbidDealerGroup: false,
  outbidDealership: false,
  isTimerExtended: false
};

export default bidContextInitialState;
